import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import mixpanel from '../../utilities/mixpanel';
import SecureRoute from '../secureRoute';
import UnknownPage from '../../pages/Unknown';
import { CONDITIONS_NOT_MET_ON_CONDITIONAL_ROUTE } from '../../constants/mixpanelEventNames';

const ConditionalRoute = ({ component, conditions, ...rest }) => {
  const { pathname } = useLocation();
  const allConditionsMet = Object.values(conditions).every(Boolean);

  if (!allConditionsMet) {
    mixpanel.track(CONDITIONS_NOT_MET_ON_CONDITIONAL_ROUTE, { URL: pathname, conditions });
  }

  // send to 404 if all conditions in object are not met
  // send through secure route for extra layer of security
  return <SecureRoute {...rest} component={allConditionsMet ? component : UnknownPage} />;
};

ConditionalRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
  conditions: PropTypes.shape({}).isRequired,
};

export default ConditionalRoute;
